console.log("circuly.js loaded");
const apiKey = getApiKey();
deleteCartCookieIfCheckoutComplete();
addLoaderToPage();

function getApiKey() {
  return "tRjxJohSuF1nKiCvio2tKr9O6ChVJP";
}

async function deleteCartCookieIfCheckoutComplete() {
  const cartData = await getCart();
  const { already_paid } = await getServerCart(cartData.token);
  if (already_paid) {
    deleteCartCookie();
  }
}

async function submitCart() {
  let spinner = document.querySelector(".loading-spinner");
  if (spinner) {
    spinner.classList.remove("none");
  }
  let { token } = await checkCarts(1);
  const checkoutUrl =
    "https://checkout.parently.se/tRjxJohSuF1nKiCvio2tKr9O6ChVJP/" + token;
  window.location.href = checkoutUrl;
}

async function getCart() {
  try {
    const response = await fetch("/cart.js");
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getServerCart(token) {
  try {
    const response = await fetch(
      "https://checkout2.api.circuly.io/v1/tRjxJohSuF1nKiCvio2tKr9O6ChVJP/cart/" +
        token
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

function deleteCartCookie() {
  document.cookie.split(";").forEach((c) => {
    const splitCookie = c.split("=");
    if (splitCookie[0].trim() === "cart") {
      document.cookie =
        "cart" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    location.reload();
  });
}

async function checkCarts(numChecks) {
  const cartData = await getCart();
  const serverCart = await getServerCart(cartData.token);
  const match = cartMatches(cartData, serverCart);
  if (match || numChecks === 5) {
    return {
      token: cartData.token,
    };
  }
  await waitFor(1);
  return checkCarts(numChecks + 1);
}

function cartMatches(
  { item_count, total_price },
  { cart_total_quantity, sum_total }
) {
  const sameNumberOfItems = item_count === cart_total_quantity;
  const sameCartValue = total_price / 100 === sum_total;
  if (sameNumberOfItems && sameCartValue) {
    return true;
  }
}

function waitFor(sec) {
  return new Promise((resolve) => setTimeout(resolve, sec * 1000));
}

function addLoaderToPage() {
  const button = document.getElementById("checkout");
  if (!button) {
    return;
  }
  const style = document.createElement("style");
  style.type = "text/css";
  style.innerHTML =
    ".loading-spinner {width: 20px; height: 20px; border-radius: 50%; background: conic-gradient(#0000 10%,#25b09b); -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 4px),#000 0); margin-right: 10px; animation:s3 1s infinite linear; } @keyframes s3 {to{transform: rotate(1turn)} } .none { display: none; }";
  document.getElementsByTagName("head")[0].appendChild(style);
  const element = document.createElement("span");
  element.classList.add("loading-spinner", "none");
  button.prepend(element);
}
